(function($){
  require('./unevent');
  module.exports = function($target){
    "use strict";

    if(Modernizr.mq('only screen and (min-width: 719px)')){
      $target.find(".home-diagram-target").each(function(){
        var $dot = $target.find("#homediag-"+$(this).data("target")),
            $message = $(this),
            top,
            left;

        if($message.hasClass("l-rightalign")){
          left = $dot.offset().left - $target.offset().left - $message.width() - 22;
        } else {
          left = $dot.offset().left - $target.offset().left + 9 + 22;
        }

        top = $dot.offset().top - $target.offset().top - 8;

        if($message.data("left")){
          left += $message.data("left");
        }
        if($message.data("top")){
          top += $message.data("top");
        }
        if($(this).hasClass("home-diagram-readmore")){
          left -= ($(this).width() * 0.5) + 60;
          top += $(this).height() * 5;
          // if(Modernizr.mq('only screen and (max-width: 1023px)')){
          // }
        }

        $(this).css({
          "top": top,
          "left": left
        });

        Waypoint.refreshAll();
      });
    } else {
      $target.find(".home-diagram-target").css({top:0, left:0});
    }

  };
})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/modules/homediagram.js
 ** module id = 8
 ** module chunks = 1
 **/